var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":"/temp/no_data.png","alt":"logo"}}),_c('span',[_vm._v(" 暂无遗体进厅，未获取订单数据")])])
}]

export { render, staticRenderFns }